import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as ConfigService from 'services/mailing/configuration';

export const useMailingConfigService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchConfiguration = async (options = {}) => {
    const { error, payload } = await ConfigService.read({ ...options, token });
    if (error) {
      return {
        configurations: [],
        size: 0
      };
    }

    const {
      data: configurations,
      meta: { size }
    } = payload;
    return { configurations, size };
  };

  const generateRecords = async (options = {}) => {
    const { error, payload } = await ConfigService.generateRecords({
      data: { ...options },
      token
    });

    if (error) {
      toast.error('Unable to generate DNS records at this time. Please try again.');
      return null;
    }

    toast.success('DNS records generated successfully.');
    return payload;
  };

  const updateConfiguration = async (id, options = {}) => {
    const { error, payload } = await ConfigService.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to update DNS records at this time. Please try again.');
      return null;
    }

    toast.success('DNS records updated successfully.');
    return payload;
  };

  const validateRecords = async (options = {}, tries = 0) => {
    const { error, payload } = await ConfigService.validateRecords({
      ...options,
      token
    });

    if (!payload && tries < 5) return await validateRecords(options, tries + 1);
    return { payload, error };
  };

  return { fetchConfiguration, generateRecords, updateConfiguration, validateRecords };
};
